import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    setCurrentActiveLucket,
    addLucketToSession,
    removeLucketFromSession
} from '../../sessionWatchSlice';
import { filteredBucketList } from '../../../../../buckets/slice/lucket-model/filterBuckets';
import { STEP_OPTION, TIMEFRAME } from '../../../../../buckets/constants';
import LucketActionStatusIcon from '../../../../../buckets/lucket/lucketActionStatusIcon/LucketActionStatusIcon.cmp';
import './ActiveLucketManager.css';

export const ActiveLucketManager = () => {
    const dispatch = useDispatch();
    const buckets = useSelector((state) => state.bucketList.buckets);
    const currentDate = useSelector((state) => state.bucketList.currentDate);
    const plannedLuckets = useSelector((state) => state.timeCounter.plannedLuckets);
    const activeLuckets = useSelector((state) => state.timeCounter.activeLuckets);
    const currentActiveLucketId = useSelector((state) => state.timeCounter.currentActiveLucketId);

    // Get full lucket objects
    const allActiveBuckets = (buckets && currentDate)
        ? filteredBucketList(buckets, STEP_OPTION.Do, TIMEFRAME.Day, currentDate).filter(l => l && l.actionStatus)
        : [];

    const plannedLucketObjects = allActiveBuckets.filter(l => l && plannedLuckets.includes(l.rowID));
    const activeLucketObjects = allActiveBuckets.filter(l => l && activeLuckets.includes(l.rowID));
    const currentActiveLucket = allActiveBuckets.find(l => l && l.rowID === currentActiveLucketId);

    const handleSetActive = (lucketRowId) => {
        if (currentActiveLucketId === lucketRowId) {
            // Deactivate if clicking the already active one
            dispatch(setCurrentActiveLucket(null));
        } else {
            dispatch(setCurrentActiveLucket(lucketRowId));
        }
    };

    const handleAddLucket = (lucketRowId) => {
        dispatch(addLucketToSession(lucketRowId));
    };

    const handleRemoveLucket = (lucketRowId) => {
        dispatch(removeLucketFromSession(lucketRowId));
    };

    return (
        <div className="active-lucket-manager">
            {/* Currently Working On */}
            {currentActiveLucket && (
                <div className="current-lucket-section">
                    <h3>Currently Working On:</h3>
                    <div className="current-lucket-card">
                        <LucketActionStatusIcon actionStatus={currentActiveLucket.actionStatus} />
                        <span className="lucket-name">{currentActiveLucket.name}</span>
                        <button
                            className="stop-working-btn"
                            onClick={() => handleSetActive(null)}
                        >
                            Stop Working
                        </button>
                    </div>
                </div>
            )}

            {/* Planned Luckets */}
            {plannedLucketObjects.length > 0 && (
                <div className="planned-luckets-section">
                    <h3>Planned Luckets:</h3>
                    {plannedLucketObjects.map((lucket) => (
                        <div
                            key={lucket.rowID}
                            className={`lucket-card ${currentActiveLucketId === lucket.rowID ? 'active' : ''}`}
                        >
                            <LucketActionStatusIcon actionStatus={lucket.actionStatus} />
                            <span className="lucket-name">{lucket.name}</span>
                            <span className="category-badge">Category {lucket.category}</span>
                            {currentActiveLucketId === lucket.rowID ? (
                                <span className="active-indicator">🟢 Active</span>
                            ) : (
                                <button
                                    className="work-on-btn"
                                    onClick={() => handleSetActive(lucket.rowID)}
                                >
                                    Start Working
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {/* Other Active Luckets (added during session) */}
            {activeLucketObjects.filter(l => !plannedLuckets.includes(l.rowID)).length > 0 && (
                <div className="other-luckets-section">
                    <h3>Added During Session:</h3>
                    {activeLucketObjects
                        .filter(l => !plannedLuckets.includes(l.rowID))
                        .map((lucket) => (
                            <div
                                key={lucket.rowID}
                                className={`lucket-card ${currentActiveLucketId === lucket.rowID ? 'active' : ''}`}
                            >
                                <LucketActionStatusIcon actionStatus={lucket.actionStatus} />
                                <span className="lucket-name">{lucket.name}</span>
                                <span className="category-badge">Category {lucket.category}</span>
                                {currentActiveLucketId === lucket.rowID ? (
                                    <span className="active-indicator">🟢 Active</span>
                                ) : (
                                    <button
                                        className="work-on-btn"
                                        onClick={() => handleSetActive(lucket.rowID)}
                                    >
                                        Start Working
                                    </button>
                                )}
                                <button
                                    className="remove-btn"
                                    onClick={() => handleRemoveLucket(lucket.rowID)}
                                >
                                    ×
                                </button>
                            </div>
                        ))
                    }
                </div>
            )}

            {/* Add More Luckets */}
            <div className="add-lucket-section">
                <select
                    onChange={(e) => {
                        if (e.target.value) {
                            handleAddLucket(e.target.value);
                            e.target.value = ""; // Reset
                        }
                    }}
                    className="add-lucket-dropdown"
                >
                    <option value="">+ Add Another Lucket</option>
                    {allActiveBuckets
                        .filter(l => !activeLuckets.includes(l.rowID))
                        .map((lucket) => (
                            <option key={lucket.rowID} value={lucket.rowID}>
                                {lucket.name} (Category {lucket.category})
                            </option>
                        ))
                    }
                </select>
            </div>
        </div>
    );
};
